/**
 * Site configuration derived from environment variables with fallbacks
 */

// Helper to safely get environment variables with defaults
function getEnv(key: string, defaultValue: string): string {
  // For client-side, access through import.meta.env
  // Note: Only variables prefixed with VITE_ are exposed to the client
  if (typeof import.meta !== "undefined" && import.meta.env) {
    return import.meta.env[key] || defaultValue;
  }

  // For server-side, access through process.env
  if (typeof process !== "undefined" && process.env) {
    return process.env[key] || defaultValue;
  }

  return defaultValue;
}

// Site configuration with environment variables and defaults
export const siteConfig = {
  title: getEnv("VITE_SITE_TITLE", "Shingle Guard"),
  description: getEnv(
    "VITE_SITE_DESCRIPTION",
    "Innovative roof restoration solutions that extend roof life by 6-15 years. Serving Saskatoon, Saskatchewan since 2025.",
  ),
  url: getEnv("VITE_SITE_URL", "https://shingleguard.ca"),
  companyName: getEnv("VITE_COMPANY_NAME", "Shingle Guard Roofing"),
  foundingYear: 2025,
  contactPhone: getEnv("VITE_CONTACT_PHONE", "13063713760"),
  contactEmail: getEnv("VITE_CONTACT_EMAIL", "info@shingleguard.ca"),
  contactAddress: getEnv(
    "VITE_CONTACT_ADDRESS",
    "123 Roofing Lane, Saskatoon, SK S7K 1K1",
  ),
  mondayToFriday: getEnv("VITE_BUSINESS_HOURS_WEEKDAY", "8:00 AM - 6:00 PM"),
  saturday: getEnv("VITE_BUSINESS_HOURS_SATURDAY", "9:00 AM - 4:00 PM"),
  sunday: getEnv("VITE_BUSINESS_HOURS_SUNDAY", "Closed"),

  // Add other site-wide configuration as needed
  defaultLocale: "en",
  defaultOgImage: "/images/hero_background.jpg",
};

/**
 * Generate base document properties using site configuration
 */
export function getBaseDocumentProps(overrides?: Partial<typeof siteConfig>) {
  const config = { ...siteConfig, ...overrides };

  return {
    title: config.title,
    description: config.description,
    language: config.defaultLocale,
    canonicalUrl: config.url,

    // Open Graph
    ogTitle: config.title,
    ogDescription: config.description,
    ogImage: config.defaultOgImage,
    ogUrl: config.url,
    ogType: "website",

    // Remove Twitter card metadata since we don't use social media
  };
}
